<template>
  <!--  v-if="!manualHiddenProfile && (showProfile || showGuideBtn || showCalendar)"-->
  <div
    v-if="false"
    class="narrator"
    :class="[
      shouldPanoramasListShow ? 'narrator-up' : '',
      property.objectId ? 'narrator-property' : ''
    ]"
  >
    <NarratorProfile
      v-if="showProfile"
      :dataset="profile"
    />
    <NarratorCalendarBtn
      v-if="showCalendarBtn"
      :column="isFullWidth"
      @showCalendar="showCalendar"
    />
    <NarratorGuideBtn
      v-if="showGuideBtn"
      :column="isFullWidth"
      @showCalendar="showCalendar"
    />
    <modal-booking
      ref="ModalBooking"
      :company="profile.companyDisplayName || $t('None')"
      :calendar="currentBuilding.calendar"
      :bookings="currentBuilding.bookings"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NarratorProfile from './Profile'
import NarratorGuideBtn from './GuideBtn'
import NarratorCalendarBtn from './CalendarBtn'
import queryString from '../../../api/query-string'
import ModalBooking from '../modals/ModalBooking'

export default {
  name: 'NarratorIndex',
  components: {
    NarratorProfile,
    NarratorGuideBtn,
    NarratorCalendarBtn,
    ModalBooking
  },

  props: {
    shouldPanoramasListShow: {
      required: true,
      type: Boolean
    }
  },

  computed: {
    ...mapGetters([
      'user',
      'currentBuilding',
      'property'
    ]),

    showProfile () {
      return this.currentBuilding.showContactInfo
    },

    showGuideBtn () {
      return this.currentBuilding.tourRingBtn
    },

    showCalendarBtn () {
      return this.currentBuilding.calendar
    },

    manualHiddenProfile () {
      return queryString.hideContactInfo
    },

    profile () {
      const {
        showAdminProfile,
        adminProfile
      } = this.user

      return showAdminProfile && adminProfile ? adminProfile : this.user
    },

    isMoblie () {
      return !!this.$device.mobile()
    },

    isFullWidth () {
      return this.isMoblie && this.showProfile
    }
  },

  methods: {
    showCalendar () {
      this.$refs.ModalBooking.show()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

.narrator {
  display: flex;
  position: fixed;
  bottom: 90px;
  right: 14px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3;

  @media (min-width: $response) {
    right: 36px;
  }

  &.narrator-up {
    bottom: 204px;

    @media (min-width: $response) {
      bottom: 90px;
    }

    &.narrator-property {
      bottom: 238px;

      @media (min-width: $response) {
        bottom: 90px;
      }
    }
  }

  @media (min-width: $response) {
    align-items: flex-start
    bottom: 90px;
  }

  .narrator-guide-btn, .narrator-calendar-btn {
    flex-grow: 1;
    flex-shrink: 0;
  }
}
</style>
